import { getDimensions, getMetrics, getDataType } from '../report/configReportGetters';
export const getIsPreviousReportValidAsBase = (previousReport, columns, dataType) => {
  try {
    if (!previousReport || getDataType(previousReport) !== dataType) {
      return false;
    }
    const columnNames = new Set(columns.map(column => column.name));
    const previousDimensions = getDimensions(previousReport);
    const previousMetrics = getMetrics(previousReport);
    const previousDimensionsUnchanged = previousDimensions.every(dim => columnNames.has(dim));
    const previousMetricsUnchanged = previousMetrics.every(previousMetric => {
      const property = previousMetric.get('property');
      return property === 'count' || columnNames.has(property);
    });
    return previousDimensionsUnchanged && previousMetricsUnchanged;
  } catch (e) {
    return false;
  }
};